import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import * as constans from "../const/constants";
import routes from "../assets/apiRoutes.json"
import SelectBox from 'devextreme-react/select-box';
import axios from "axios";
const LoadIframe = (props) => {
    var oidc = props.oidc;
    var accessToken = props.oidc.user.access_token;
    var userName = props.oidc.user.profile.name;
    var webUserInfo = props.oidc.user.profile.webUserInfo;
    const parsedData = JSON.parse(webUserInfo);
    const userCompanyId = parsedData.userCompanyId;
    const { reportType } = useParams();
    const [source, setSource] = useState('');
    const [warehouse, setWarehouse] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();
    const GetPageUrl = () =>{
        if (reportType == constans.EarlyTagReport) {
            return "/PTR/EarlyTagReport";
        }else if (reportType == constans.DashboardManagement) {
            return "/HOME/Index";
        }else if (reportType == constans.PTRDailyUpdates) {
            return "/PTR/DailyUpdates";
        }else if (reportType == constans.PTRDailyUpdates2) {
            return "/PTR/DailyUpdates2";
        }else if (reportType == constans.PTRConfiguration) {
            return "/PTR/Configuration";
        }else if (reportType == constans.PTROverrides) {
            return "/PTR/Overrides";
        }else if (reportType == constans.PTRAttributes) {
            return "/PTR/Attributes";
        }else if (reportType == constans.PTRRules) {
            return "/PTR/Rules";
        }else if (reportType == constans.PTRCropRollTool) {
            return "/PTR/CropRollTool";
        }
    }
    const handleLoadIframe = (warehouseId) => {
        var url = `${window._env_.PTR_Base_URL}${GetPageUrl()}?warehouseRowId=${encodeURIComponent(warehouseId)}&userName=${encodeURIComponent(userName)}&userCompanyId=${encodeURIComponent(userCompanyId)}`;
        setSource(url);
    };
    const fetchWareHouseList = async () => {
        try {
            const url = `${window._env_.REACT_APP_APIS}/${routes.PTR.GetWarehouselist}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to fetch schedule data');
            }
            const result = await response.json();
            setWarehouse(result.data);
            var wh = props.oidc.user.profile?.warehouse;
            if(wh != undefined && wh != "" && wh != null){
                setSelectedWarehouse(wh);
                handleLoadIframe(wh);
            }
        } catch (err) {
            console.error('Data Loading Error:', err);
        }
    };
    const addClaimsToUser = async (val) => {
        var addClaimObject = {
            UserId: oidc.user.profile.sub,
            Type: "warehouse",
            Value: val,
        };
        axios
            .post(
                `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.addClaim}`,
                addClaimObject,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((result) => {
            });
    };
const handelValueDateChanged = async (e) => {
    const selectedwarehouse = e.value;
    setSelectedWarehouse(selectedwarehouse);
    addClaimsToUser(selectedwarehouse);
    handleLoadIframe(selectedwarehouse);
};
useEffect(() => {
    fetchWareHouseList();
}, [reportType]);
return (
    <div style={{ width: "100%", height: "100%" }}>
        <div style={{ display: 'flex', marginBottom: '10px' }}>
            <div style={{ flex: 1 }}>
                <SelectBox
                    dataSource={warehouse}
                    displayExpr="name"
                    valueExpr="id"
                    value={selectedWarehouse}
                    labelMode="static"
                    label="warehouse"
                    placeholder="Select a warehouse"
                    onValueChanged={handelValueDateChanged}
                />
            </div>
        </div>
        <iframe src={source} height="90%" width="100%" style={{ border: "none" }}></iframe>
    </div>
);
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LoadIframe);